import { getLocale } from "../runtime";

const sv_becountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Belgien`
};

const becountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_becountry(inputs)
	return "beCountry";
};

export { becountry as "beCountry" };